import ajax from '@/lib/ajax';
import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';
import { AppModule } from '@/store/Auth/AppModule';
import Institution from '@/models/Settings/Institutions/Institution';
import PermissionUtils from '@/lib/permissionUtils';

export interface IInstitutionsState {
    loading: boolean;
    institutions: Institution[];
    institutionLoggedIn: Institution;
    institution: Institution;
    pageSize: number;
}

@Module({ dynamic: true, store, name: 'InstitutionsModule', namespaced: true })
class InstitutionsStore extends VuexModule implements IInstitutionsState {

    public loading: boolean = true;
    public institutions: Institution[] = [];
    public institutionLoggedIn: Institution = new Institution();
    public institution: Institution = new Institution();
    public pageSize: number = PermissionUtils.getPageSize();

    @Action
    async getInstitutions(id: string) {

        this.setLoading(true);

        await ajax.get(`/portal-backend/fi-api/internal/institutions/${id}`)
        .then(response => {
            // This is a mockup of how getInstitutions should work when it is available in the future, it should
            // return an array of institutions and not require an ID to be passed in, just GET /institutions
            const institutionsArray = [response.data];
            this.context.commit("setInstitutions", institutionsArray);
            this.setLoading(false);
        })
        .catch(error => {
            AppModule.handleApiError(error);
            this.setLoading(false);
        });
    }

    @Action
    async getInstitutionLoggedIn(id: string) {

        // This action will get and then set the Institution that the portal user is currently logged into
        // This is different to the plain "institution" field in this module which is just the institution
        // that is currently being viewed in the list of all Institutions, in cases where there are more
        // than one institution this could be different to the one tha the user is logged into

        this.setLoading(true);

        await ajax.get(`/portal-backend/fi-api/internal/institutions/${id}`)
        .then(response => {
            this.context.commit("setInstitutionLoggedIn", response.data);
            this.setLoading(false);
        })
        .catch(error => {
            AppModule.handleApiError(error);
            this.setLoading(false);
        });
    }

    @Action
    async getInstitution(id: string) {

        this.setLoading(true);

        await ajax.get(`/portal-backend/fi-api/internal/institutions/${id}`)
        .then(response => {
            this.context.commit("setInstitution", response.data);
            this.setLoading(false);
        })
        .catch(error => {
            AppModule.handleApiError(error);
            this.setLoading(false);
        });
    }

    @Action
    cleanState() {
        this.context.commit("resetState");
    }

    @Mutation
    resetState() {
        this.loading = true;
        this.institutions = [];
        this.institution = new Institution();
        this.institutionLoggedIn = new Institution();
    }

    @Mutation
    private async setLoading(loading: boolean) {
        this.loading = loading;
    }

    @Mutation
    private async setInstitutions(response: Institution[]) {
        if (response) {
            this.institutions = response;
        }
    }

    @Mutation
    private async setInstitution(response: Institution) {
        this.institution = response;
    }

    @Mutation
    private async setInstitutionLoggedIn(response: Institution) {
        this.institutionLoggedIn = response;
    }

}

export const InstitutionsModule = getModule(InstitutionsStore);